import { Component, EventEmitter, input, Output } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { TpMainSectorsResponse } from "../../../models";

@Component({
  selector: "adaa-tp-main-sectors",
  imports: [TranslatePipe, TranslateTokenPipe],
  templateUrl: "./tp-main-sectors.html",
  styleUrl: "./tp-main-sectors.scss",
})
export class TpMainSectorsComponent {
  sectors = input.required<TpMainSectorsResponse>();

  @Output() cardClicked = new EventEmitter<number>();
}
